import { useTranslation } from 'react-i18next';
import { Icon, Text } from '@shared/widgets';
import EyeIcon from '@assets/icons/eye.svg';

interface ShowInReportsProps {
  icon?: React.ReactNode;
  showModal: () => void;
}

export const ShowInReports = (props: ShowInReportsProps) => {
  const { t } = useTranslation();

  return (
    <div className='flex cursor-pointer items-center' onClick={props.showModal}>
      {props.icon ? (
        <div className='mr-1'>{props.icon}</div>
      ) : (
        <div className='mr-1 opacity-60'>
          <Icon icon={<EyeIcon width='18' height='18' />} />
        </div>
      )}
      <Text className='underline'>{t('buttons.show')}</Text>
    </div>
  );
};
